import { call, put, takeEvery } from 'typed-redux-saga'
import { fnsApi, registratorCabinetActions, FnsNS } from 'Pages/registratorCabinet'
import { errorHandler, loadersSlice, NOTIFICATION_TYPE, showNotificationAction } from 'Modules'

function* getContainerRaspiskaRbidosRequest(action: FnsNS.getContainerRaspiskaRbidosRequest) {
	try {
		const { callback } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(fnsApi.getContainerRaspiskaRbidosRequest, action.payload.id)
		callback?.(res)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* getContainerResponseRbidosRequest(action: FnsNS.getContainerResponseRbidosRequest) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(fnsApi.getContainerResponseRbidosRequest, action.payload.id)
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.SUCCESS,
				message: 'Ссылка отправлена на почту',
			})
		)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* fnsSaga() {
	yield* takeEvery(
		registratorCabinetActions.getContainerRaspiskaRbidosRequest.type,
		getContainerRaspiskaRbidosRequest
	)
	yield* takeEvery(
		registratorCabinetActions.getContainerResponseRbidosRequest.type,
		getContainerResponseRbidosRequest
	)
}
